import { arrType, datatypes, inputTypes } from "data/globalData";

export const FRANCHISE_OPTIONS = [
	{
		label: "SHIVERA LIFESTYLE PRIVATE LIMITED",
		value: "shivera_lifestyle_private_limited",
	},
	{
		label: "RENE FASHION",
		value: "rene_fashion",
	},
	{
		label: "SHIV SHANTI GARMENTS",
		value: "shiv_shanti_garments",
	},
	{
		label: "K J LIFESTYLE LLP AP",
		value: "kj_lifestyle_llp_ap",
	},
	{
		label: "K J LIFESTYLE LLP KL",
		value: "kj_lifestyle_llp_kl",
	},
	{
		label: "K J LIFESTYLE LLP TS",
		value: "kj_lifestyle_llp_ts",
	},
];

export const FRANCHISE_MAPPING = {
	shivera_lifestyle_private_limited: "SHIVERA LIFESTYLE PRIVATE LIMITED",
	rene_fashion: "RENE FASHION",
	shiv_shanti_garments: "SHIV SHANTI GARMENTS",
	kj_lifestyle_llp_ap: "K J LIFESTYLE LLP AP",
	kj_lifestyle_llp_kl: "K J LIFESTYLE LLP KL",
	kj_lifestyle_llp_ts: "K J LIFESTYLE LLP TS",
};

export const FRANCHISE_FIELDS = [
	{
		name: "Franchise",
		key: "franchise",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		option_data: {
			type: arrType,
			list: FRANCHISE_OPTIONS,
			getOptionLabel: (row) => {
				return { name: row.label, key: row.value };
			},
		},
	},
	{
		name: "Start Date",
		key: "start_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
	},
	{
		name: "End Date",
		key: "end_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
	},
];

export const FRANCHISE_MAPPING_FIELDS = [
	{
		name: "Franchise Name",
		key: "franchise_name",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		option_data: {
			type: arrType,
			list: FRANCHISE_OPTIONS,
			getOptionLabel: (row) => {
				return { name: row.label, key: row.label };
			},
		},
	},
	{
		name: "Mapped Stores",
		key: "mapped_stores",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
];
